import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { ProductInput } from '../../gql/graphql';

interface AdvancedTabProps {
	productData: Partial<ProductInput>;
	updateProductData: (updates: Partial<ProductInput>) => void;
}

function AdvancedTab({ productData, updateProductData }: AdvancedTabProps) {
	const handleChange = (field: keyof ProductInput) => (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		updateProductData({ [field]: event.target.value });
	};

	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Advanced Settings
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Additional product information and custom fields
			</Typography>

			<Grid container spacing={3}>
				{/* Nutrition Info */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						multiline
						rows={6}
						label="Nutrition Information"
						name="nutritionInfo"
						value={productData.nutritionInfo || ''}
						onChange={handleChange('nutritionInfo')}
						helperText="For food products: Enter nutrition facts in JSON format or plain text"
						placeholder={`Example:\n{\n  "calories": 250,\n  "protein": "10g",\n  "carbs": "30g",\n  "fat": "8g"\n}`}
					/>
				</Grid>

				{/* MongoDB Reference ID */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="MongoDB Reference ID"
						name="mongoReferenceId"
						value={productData.mongoReferenceId || ''}
						onChange={handleChange('mongoReferenceId')}
						helperText="Optional: Link to legacy MongoDB product record"
						disabled
					/>
				</Grid>

				{/* Future Custom Fields */}
				<Grid item xs={12}>
					<Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
						<Typography variant="body2" color="text.secondary">
							Additional custom fields can be added here in future updates based on your business needs.
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AdvancedTab;
